import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import useAppContext, { actions } from "../../../utils/Reducers";
import { useAxiosWithAuthorization } from "../../../utils/api";

import "../../../styles/css/login.css";
import { ModalGradeConfirmPop } from "../popup/GradeConfirmPop";

const Outgoing = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    async onSearch(item) {
      await handleMasterSearch(item);
    },
  }));

  const [searchData, setSearchData] = useState([]);

  const [statusI, setStatusI] = useState("");

  const {
    store: { userInfo },
  } = useAppContext();

  const SEARCH_OUTGOING_WAIT_LIST =
    "/mobileweb/outgoing/SP_SEARCH_OUTGOING_WAIT_LIST.do";

  const SEARCH_OUTGOING_SEA_WAIT_LIST =
    "/mobileweb/outgoing/SP_SEARCH_OUTGOING_SEA_WAIT_LIST.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_OUTGOING_WAIT_LIST,
    },
    { manual: true }
  );

  useEffect(async () => {
    await handleMasterSearch(props.searchParameters);
  }, []);

  const handleMasterSearch = async (item) => {
    const {
      data: { data },
    } = await fetchData({
      url:
        props.bmenuTab === "scrap"
          ? SEARCH_OUTGOING_WAIT_LIST
          : SEARCH_OUTGOING_SEA_WAIT_LIST,
      params: item,
    });
    //console.log(data);
    setSearchData(data);
    setStatusI(data.length);
  };

  const onGradeConfirm = (data) => {
    ModalGradeConfirmPop({
      inspData: data,
      onClose: onClose,
    });
  };

  //팝업 데이터 가져오기
  const onClose = useCallback(async () => {
    handleMasterSearch();
  });

  return (
    <>
      <div id="menu2" className="list">
        {searchData &&
          searchData?.map((data, index) => {
            return (
              <div key={index} onClick={(event) => onGradeConfirm(data)}>
                <div className="ctitle">
                  <h1 className="carno">{data.vhclNo}</h1>
                  <div>
                    {data.warmCnt > 0 ? <button className="al"></button> : ""}
                    {data.outageWght > 0 ? (
                      <div className="nums">-{data.outageWght}</div>
                    ) : (
                      ""
                    )}
                    {data.returnCnt > 0 ? (
                      <button className="close"></button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="cinfo">
                  <div>
                    <h2>{data.dcsnItemNm}</h2>
                  </div>
                  <div className="no">
                    <h2>{data.inspNo}</h2>
                  </div>
                  <div>
                    <div className="stat calling">하차</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.scrapAreaNm}
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="cinfo">
                  <div>
                    <h2>{data.loadAreaAddr}</h2>
                  </div>
                  <div className="phone">
                    <h2>{data.drivTel}</h2>
                  </div>
                  <div>
                    <div className="stat arrive">입차</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.inptDt}
                      </h2>
                    </div>
                  </div>
                  <div className="com">
                    <h2>
                      {data.vndrNm} / {data.rvndrNm}
                    </h2>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {searchData?.length > 0 ? (
        <div className="res">
          <div>
            <div>출차대기</div>
            <div className="val">
              <div>{statusI}</div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
});

export default Outgoing;
